import React, { useContext, useEffect, useState } from 'react';
import { Input } from '../../components/ui/input';
import { Separator } from '../../components/ui/separator';
import {
    Table,
    TableBody,
    TableCaption,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "../../components/ui/table";
import { Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious } from '../../components/ui/pagination';
import { Link } from 'react-router-dom';
import { ApiContext } from './../context/AdminContext.jsx';

const token = localStorage.getItem("adminToken");

const AppliedProvider = () => {
    const { partners, setPartner } = useContext(ApiContext);
    const [searchTerm, setSearchTerm] = useState("");
    const [statusFilter, setStatusFilter] = useState("all");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    // Filter partners based on search and status
    const filteredPartners = partners?.filter(partner => {
        const matchesSearch = partner?.Profile?.name?.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesStatus = statusFilter === "all" || partner?.Profile?.KYC?.status === statusFilter;
        return matchesSearch && matchesStatus;
    });

    // Paginate services
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentServices = filteredPartners?.slice(indexOfFirstItem, indexOfLastItem);

    // Handle pagination clicks
    const totalPages = Math.ceil(filteredPartners?.length / itemsPerPage);
    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    const maxVisiblePages = 10;
    const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Reset to first page when filters change
    useEffect(() => {
        setCurrentPage(1);
    }, [statusFilter, searchTerm]);

    const getStatusBadge = (status) => {
        switch (status) {
            case "approved":
                return <span className='text-green-600 bg-green-100 px-2 py-1 rounded-md'>Approved</span>;
            case "rejected":
                return <span className='text-red-600 bg-red-100 px-2 py-1 rounded-md'>Rejected</span>;
            case "pending":
                return <span className='text-orange-600 bg-orange-100 px-2 py-1 rounded-md'>Pending</span>;
            default:
                return <span className='text-gray-600 bg-gray-100 px-2 py-1 rounded-md'>{status}</span>;
        }
    };
  if (!partners || partners?.length === 0) {
     return<div className="flex items-center justify-center h-screen">
           <button
  disabled=""
  class="bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold py-3 px-6 rounded-full shadow-lg flex items-center transition duration-300 transform hover:scale-105 active:scale-95"
>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="animate-spin h-5 w-5 mr-3 text-white"
  >
    <circle
      stroke-width="4"
      stroke="currentColor"
      r="10"
      cy="12"
      cx="12"
      class="opacity-25"
    ></circle>
    <path
      d="M4 12a8 8 0 018-8v8H4z"
      fill="currentColor"
      class="opacity-75"
    ></path>
  </svg>
  Loading...
</button>
    </div>
  }
    return (
        <div className='px-[1vw] my-5'>
            <div className='flex lg:justify-between lg:items-center flex-col lg:flex-row '>
                <h1 className='text-2xl'>Provider Application</h1>
                <div className='flex lg:gap-4 items-center gap-2 my-3 lg:my-0'>
                    <Input 
                        placeholder='Search by name'
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <select
                        className="border rounded-md p-2 text-sm"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                    >
                        <option value="all">All Status</option>
                        <option value="pending">Pending</option>
                        <option value="approved">Approved</option>
                        <option value="rejected">Rejected</option>
                    </select>
                </div>
            </div>
            <Separator className='my-4' />
            <div className='overflow-x-auto lg:max-w-[1000px] max-w-[380px] md:max-w-[580px] lg:h-[65vh] h-[58vh] md:h-[70vh]'>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead className='truncate'>Sl No.</TableHead>
                            <TableHead className='truncate'>Provider Name</TableHead>
                            <TableHead className='truncate'>Applied Date</TableHead>
                            <TableHead className='truncate'>Phone No</TableHead>
                            <TableHead className='truncate'>Email</TableHead>
                            <TableHead className='truncate'>Address</TableHead>
                            <TableHead className='truncate'>Status</TableHead>
                            <TableHead className='truncate'>View All Details</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {currentServices?.length > 0 ? (
                            currentServices?.map((partner, ind) => {
                                return (
                                    <TableRow key={partner?.Profile?.id}>
                                        <TableCell>{indexOfFirstItem + ind + 1}</TableCell>
                                        <TableCell>{partner?.Profile?.name}</TableCell>
                                        <TableCell className='truncate'>{new Date(partner?.Profile?.createdAt).toISOString().split("T")[0]}</TableCell>
                                        <TableCell>{partner?.Profile?.phone}</TableCell>
                                        <TableCell className='truncate'>{partner?.Profile?.email}</TableCell>
                                        <TableCell className='truncate'>{partner?.Profile?.address}</TableCell>
                                        <TableCell className='truncate'>
                                            {getStatusBadge(partner?.Profile?.KYC?.status)}
                                        </TableCell>
                                        <TableCell>
                                            <Link to={`/admin/applied_provider_details/${partner?.Profile?.id}`}>
                                                <span 
                                                    className='hover:underline cursor-pointer text-blue-600'
                                                    onClick={() => { setPartner(partner) }}
                                                >
                                                    View Details
                                                </span>
                                            </Link>
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        ) : (
                            <TableRow>
                                <TableCell colSpan={8} className="text-center py-4">
                                    No partners found matching your criteria
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>

            {filteredPartners?.length > 0 && (
                <div>
                    <Pagination className="mt-4">
                        <PaginationContent>
                            {currentPage > 1 && (
                                <PaginationItem>
                                    <PaginationPrevious onClick={() => handlePageChange(currentPage - 1)} />
                                </PaginationItem>
                            )}

                            {startPage > 1 && (
                                <>
                                    <PaginationItem>
                                        <PaginationLink onClick={() => handlePageChange(1)}>1</PaginationLink>
                                    </PaginationItem>
                                    {startPage > 2 && <PaginationItem><span>...</span></PaginationItem>}
                                </>
                            )}

                            {[...Array(endPage - startPage + 1)].map((_, index) => {
                                const pageNumber = startPage + index;
                                return (
                                    <PaginationItem key={pageNumber}>
                                        <PaginationLink
                                            isActive={pageNumber === currentPage}
                                            onClick={() => handlePageChange(pageNumber)}
                                        >
                                            {pageNumber}
                                        </PaginationLink>
                                    </PaginationItem>
                                );
                            })}

                            {endPage < totalPages && (
                                <>
                                    {endPage < totalPages - 1 && <PaginationItem><span>...</span></PaginationItem>}
                                    <PaginationItem>
                                        <PaginationLink onClick={() => handlePageChange(totalPages)}>{totalPages}</PaginationLink>
                                    </PaginationItem>
                                </>
                            )}

                            {currentPage < totalPages && (
                                <PaginationItem>
                                    <PaginationNext onClick={() => handlePageChange(currentPage + 1)} />
                                </PaginationItem>
                            )}
                        </PaginationContent>
                    </Pagination>
                </div>
            )}
        </div>
    );
};

export default AppliedProvider;